import { createModel } from "@/util/ModelUtil";

export default class OrganizationModel {
  constructor(
    public id: number = 0,
    public name: string = "",
    public companyName: string = "",
    public businessNumber: string = "",
    public code: string = "",
    public email: string = "",
    public maxUser: number = 0,
    public contractTerm: number = new Date().getDate(),
    public createdAt: number = new Date().getDate(),
    public updatedAt: number = new Date().getDate(),
    public applicationStartedAt?: string,
    public applicationEndedAt?: string,
    public subDomain?: string,
    public mainBannerImageUrl?: string,
    public mainLogoImageUrl?: string,
    public specialTrackMenuName?: string,
    public isAutoLearningStart?: boolean,
    public isLectureRemind?: boolean,
    public lectureRemindAdvertisementUrl?: string,
    public lectureRemindAdvertisementLink?: string,
    public lectureLimit?: number,
    public lectureLimitEndedAt?: string,
    public lectureLimitPeriod?: number,
    public isSingleLectureEnforced?: boolean,
    public maxConcurrentLectures?: number,
    public isRetakeAllowed?: boolean,
    public isWhitelistEnabled?: boolean,
    public isReenrollAfterCompletionAllowed?: boolean,
    public isLectureLimitExemptionEnabled?: boolean,
    public enrollmentStartedAt?: string,
    public isLectureApprovalRequired?: boolean,
    public isDirectPaymentEnabled?: boolean
  ) {}

  public static create(data?: Organization): OrganizationModel {
    return createModel<OrganizationModel>(OrganizationModel, data);
  }
}
